export function getProjectSipocSuggestRoute(apiBase, projectId) {
  return `${apiBase}/projects/${projectId}/sipoc/suggest`;
}
